export default "__VITE_ASSET__Cq$quz1P__"